import { render, staticRenderFns } from "./MegaMenuLevel3.vue?vue&type=template&id=456f23ba&"
import script from "./MegaMenuLevel3.vue?vue&type=script&lang=js&"
export * from "./MegaMenuLevel3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports